export default "__VITE_ASSET__DeZnfn35__"